const actionStateOptions = [
  { label: "Action Required", value: "actionRequired" },
  { label: "Pending Approval", value: "pendingApproval" },
  { label: "Processing", value: "processing" },
  { label: "Complete", value: "complete" },
];

const actionConfig = { actionStateOptions };

export default actionConfig;
